import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { fetchUserByUUID } from "../api/users";
import { useTranslation } from "react-i18next";

export function Home() {
  const { userId, companyRole, company, isPlatformAdmin } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (userId) {
      fetchUserByUUID(userId).then(({ data }) => {
        setUsername(data.numistrail_id);
      });
    }
  }, [userId]);

  const getActionsDescription = () => {
    const normalizedRole = (companyRole || "").toLowerCase();
    const companyType = company?.company_type;
    const trusted = company?.trusted_for_certification;

    if (isPlatformAdmin) {
      return t("home.actions.platformAdmin");
    }

    const canMint =
      normalizedRole !== "" &&
      ["admin", "expert"].includes(normalizedRole) &&
      (companyType === "CERTIFICATION_ENTITY" || trusted);

    if (normalizedRole === "admin") {
      if (companyType === "CERTIFICATION_ENTITY") {
        return t("home.actions.adminCert", { company: company?.display_name || t("home.companyFallback") });
      }
      if (canMint) {
        return t("home.actions.adminTrusted", { company: company?.display_name || t("home.companyFallback") });
      }
      return t("home.actions.admin", { company: company?.display_name || t("home.companyFallback") });
    }

    if (normalizedRole === "expert") {
      if (companyType === "CERTIFICATION_ENTITY") {
        return t("home.actions.expertCert");
      }
      if (canMint) {
        return t("home.actions.expertTrusted");
      }
      return t("home.actions.expert");
    }

    if (normalizedRole === "reports") {
      return t("home.actions.reports");
    }

    return t("home.actions.default");
  };

  return (
    <div className="home-screen">
      <div className="home-content">
        <main className="home-main">
          <h2 className="home-title">{t("home.title")}</h2>
          <p className="home-text">
            {t("home.intro", { username: username || t("home.userFallback") })}
          </p>
          <p className="home-text">{getActionsDescription()}</p>
        </main>
        <div className="legal-footer">
          <p className="legal-note">{t("legal.brandNotice")}</p>
          <div className="legal-links">
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              {t("legal.terms")}
            </a>
            <span className="legal-links__sep" aria-hidden="true">·</span>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              {t("legal.privacy")}
            </a>
            <span className="legal-links__sep" aria-hidden="true">·</span>
            <a href="/disclaimer" target="_blank" rel="noopener noreferrer">
              {t("legal.disclaimer")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
